import { useRouter } from 'next/router';

const useRedirectToFirstPage = (url: string) => {
  const router = useRouter();
  const urlPageNo = router?.asPath;
  const splitedPageNo = urlPageNo.split('=');
  // Обрезаем линий слэш - актуально для настройки next.config - trailingSlash: true
  const pageNo = splitedPageNo[splitedPageNo.length - 1].replace(/(\.|\/|)/g, '');

  if (pageNo === '1') {
    typeof window !== 'undefined' && router.push(url);
  }
};

export default useRedirectToFirstPage;
